import React, { useEffect, useState } from "react";
import { FaUsers, FaClipboardList } from "react-icons/fa";
import { IoMdTime } from "react-icons/io";
import { AiOutlineUserAdd } from "react-icons/ai";
import axios from "axios";
import { UseHrApp } from "../../utils/context";
import { CircularProgress } from "@mui/material";

export default function StatsLg() {
  const { stats, getStats, loader } = UseHrApp();

  useEffect(() => {
    getStats();
  }, []);

  return (
    <div className="invisible lg:visible">
      {loader ? (
        <div className=" w-full min-h-[50vh] flex justify-center items-center">
          <CircularProgress />
        </div>
      ) : (
        <div className="w-full grid grid-cols-4 grid-rows-1 min-h-[13em] gap-5 font-[Righteous]">
          <div class=" shad  rounded-[1.5em] p-5 flex flex-col gap-6 justify-center  ">
            <div className=" w-[60px] h-[60px]  flex justify-center items-center p-2 rounded-[50px] bg-[#CCB2FF]">
              <FaUsers size={35} />
            </div>

            <div className=" text-[#494949]">
              <p>Total Employees</p>
              <p>
                <span className=" text-2xl font-medium">
                  {stats?.totalnumber}
                </span>
                /{stats?.companycapacity}
              </p>
            </div>
          </div>
          <div class=" shad  rounded-[1.5em] p-5 flex flex-col gap-6 justify-center ">
            <div className=" w-[60px] h-[60px]  flex justify-center items-center p-2 rounded-[50px] bg-[#abe8ab]">
              <IoMdTime size={35} />
            </div>
            <div className=" text-[#494949]">
              <p>On Leave</p>
              <p>
                <span className=" text-2xl font-medium">
                  {stats?.totalonleave}
                </span>
                /{stats?.companycapacity}
              </p>
            </div>
          </div>
          <div className=" shad rounded-[1.5em] p-5 flex flex-col gap-6 justify-center ">
            <div className=" w-[60px] h-[60px]  flex justify-center items-center p-2 rounded-[50px] bg-[#FCC4AC]">
              <FaClipboardList size={35} />
            </div>
            <div className=" text-[#494949]">
              <p>Vacancies</p>
              <p>
                <span className=" text-2xl font-medium">
                  {stats.companycapacity - stats.totalnumber}
                </span>
                /{stats.companycapacity}
              </p>
            </div>
          </div>
          <div class=" shad  rounded-[1.5em] p-5 flex flex-col gap-6 justify-center ">
            <div className=" w-[60px] h-[60px]  flex justify-center items-center p-2 rounded-[50px] bg-[#90DFFA]">
              <AiOutlineUserAdd size={35} />
            </div>
            <div className=" text-[#494949]">
              <p>Total Active</p>
              <p>
                <span className=" text-2xl font-medium">
                  {stats.totalactive}
                </span>
                /{stats.companycapacity}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
